import React from "react";

import PanelWrapper from "../User/PanelWrapper";

const DashboardPage = () => {
  return (
    <PanelWrapper type="admin">
      <div className="container">
        <div className="page-header">
          <h2>Dashboard</h2>
        </div>

        <div className="page-content-card">Content here..</div>
      </div>
    </PanelWrapper>
  );
};

export default DashboardPage;
